// crm namespace — Client timeline: filters, categories, one title per wire `kind`.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "timeline.category.email": "E-mail",
    "timeline.category.note": "Note",
    "timeline.category.other": "Mise à jour",
    "timeline.category.purchase": "Achat",
    "timeline.category.session": "Séance",
    "timeline.empty": "Rien dans l'historique pour l'instant",
    "timeline.filter.all": "Tout",
    "timeline.filter.email": "E-mails",
    "timeline.filter.note": "Notes",
    "timeline.filter.purchase": "Achats",
    "timeline.filter.session": "Séances",
    "timeline.filterLabel": "Afficher",
    "timeline.kind.blog_commented": "A commenté le blog",
    "timeline.kind.booking_cancelled": "Séance annulée",
    "timeline.kind.booking_completed": "Séance terminée",
    "timeline.kind.booking_confirmed": "Séance confirmée",
    "timeline.kind.booking_confirmed_via_reminder": "Confirmée depuis le rappel",
    "timeline.kind.booking_created": "Séance réservée",
    "timeline.kind.booking_no_show": "Absence",
    "timeline.kind.booking_rescheduled": "Séance déplacée",
    "timeline.kind.consent_changed": "Consentement modifié",
    "timeline.kind.course_enrolled": "Inscription à un cours",
    "timeline.kind.interaction_call": "Appel",
    "timeline.kind.interaction_meeting": "Rencontre",
    "timeline.kind.interaction_note": "Note",
    "timeline.kind.legacy": "Activité antérieure",
    "timeline.kind.message_received": "Message reçu",
    "timeline.kind.message_replied": "Message répondu",
    "timeline.kind.note_added": "Note ajoutée",
    "timeline.kind.pathway_certificate_issued": "Certificat de parcours délivré",
    "timeline.kind.pathway_completed": "Parcours terminé",
    "timeline.kind.pathway_encouragement_sent": "Encouragement envoyé",
    "timeline.kind.pathway_feedback_sent": "Retour envoyé sur une pratique",
    "timeline.kind.pathway_enrolled": "Inscription à un parcours",
    "timeline.kind.pathway_level_completed": "Niveau de parcours terminé",
    "timeline.kind.pathway_step_completed": "Étape de parcours terminée",
    "timeline.kind.payment_refunded": "Remboursement",
    "timeline.kind.payment_succeeded": "Achat",
    "timeline.kind.session_note_saved": "Note de séance enregistrée",
    "timeline.kind.stage_changed": "Étape changée",
    "timeline.kind.pack_assigned": "Forfait attribué",
    "timeline.kind.pack_adjusted": "Forfait ajusté",
    "timeline.kind.pack_voided": "Forfait annulé",
    "timeline.kind.form_submitted": "Formulaire envoyé",
    "timeline.kind.signed_up": "S'est inscrit·e sur votre site",
    "timeline.kind.email_sent": "E-mail envoyé",
    "timeline.noteAdded": "note ajoutée",
    "timeline.packPosition": "forfait {used} sur {total}",
    "timeline.stageAuto": "Étape changée automatiquement",
    "timeline.stageManual": "Étape fixée à la main",
    "timeline.kind.created": "Fiche client créée",
    "timeline.kind.imported": "Ajouté par un import",
    "timeline.kind.merged": "Fiches fusionnées",
  },
  en: {
    "timeline.category.email": "Email",
    "timeline.category.note": "Note",
    "timeline.category.other": "Update",
    "timeline.category.purchase": "Purchase",
    "timeline.category.session": "Session",
    "timeline.empty": "Nothing on the timeline yet",
    "timeline.filter.all": "All",
    "timeline.filter.email": "Emails",
    "timeline.filter.note": "Notes",
    "timeline.filter.purchase": "Purchases",
    "timeline.filter.session": "Sessions",
    "timeline.filterLabel": "Show",
    "timeline.kind.blog_commented": "Commented on the blog",
    "timeline.kind.booking_cancelled": "Session cancelled",
    "timeline.kind.booking_completed": "Session completed",
    "timeline.kind.booking_confirmed": "Session confirmed",
    "timeline.kind.booking_confirmed_via_reminder": "Confirmed from the reminder",
    "timeline.kind.booking_created": "Session booked",
    "timeline.kind.booking_no_show": "No-show",
    "timeline.kind.booking_rescheduled": "Session rescheduled",
    "timeline.kind.consent_changed": "Consent changed",
    "timeline.kind.course_enrolled": "Enrolled in a course",
    "timeline.kind.interaction_call": "Call",
    "timeline.kind.interaction_meeting": "Meeting",
    "timeline.kind.interaction_note": "Note",
    "timeline.kind.legacy": "Earlier activity",
    "timeline.kind.message_received": "Message received",
    "timeline.kind.message_replied": "Message answered",
    "timeline.kind.note_added": "Note added",
    "timeline.kind.pathway_certificate_issued": "Pathway certificate issued",
    "timeline.kind.pathway_completed": "Pathway completed",
    "timeline.kind.pathway_encouragement_sent": "Encouragement sent",
    "timeline.kind.pathway_feedback_sent": "Practice feedback sent",
    "timeline.kind.pathway_enrolled": "Joined a pathway",
    "timeline.kind.pathway_level_completed": "Pathway level completed",
    "timeline.kind.pathway_step_completed": "Pathway step completed",
    "timeline.kind.payment_refunded": "Refund",
    "timeline.kind.payment_succeeded": "Purchase",
    "timeline.kind.session_note_saved": "Session note saved",
    "timeline.kind.stage_changed": "Stage changed",
    "timeline.kind.pack_assigned": "Pack assigned",
    "timeline.kind.pack_adjusted": "Pack adjusted",
    "timeline.kind.pack_voided": "Pack voided",
    "timeline.kind.form_submitted": "Form submitted",
    "timeline.kind.signed_up": "Signed up on your site",
    "timeline.kind.email_sent": "Email sent",
    "timeline.noteAdded": "note added",
    "timeline.packPosition": "pack {used} of {total}",
    "timeline.stageAuto": "Stage changed automatically",
    "timeline.stageManual": "Stage set by hand",
    "timeline.kind.created": "Client record created",
    "timeline.kind.imported": "Added by an import",
    "timeline.kind.merged": "Records merged",
  },
  es: {
    "timeline.category.email": "Correo",
    "timeline.category.note": "Nota",
    "timeline.category.other": "Actualización",
    "timeline.category.purchase": "Compra",
    "timeline.category.session": "Sesión",
    "timeline.empty": "Aún no hay nada en el historial",
    "timeline.filter.all": "Todo",
    "timeline.filter.email": "Correos",
    "timeline.filter.note": "Notas",
    "timeline.filter.purchase": "Compras",
    "timeline.filter.session": "Sesiones",
    "timeline.filterLabel": "Mostrar",
    "timeline.kind.blog_commented": "Comentó en el blog",
    "timeline.kind.booking_cancelled": "Sesión cancelada",
    "timeline.kind.booking_completed": "Sesión completada",
    "timeline.kind.booking_confirmed": "Sesión confirmada",
    "timeline.kind.booking_confirmed_via_reminder": "Confirmada desde el recordatorio",
    "timeline.kind.booking_created": "Sesión reservada",
    "timeline.kind.booking_no_show": "No se presentó",
    "timeline.kind.booking_rescheduled": "Sesión reprogramada",
    "timeline.kind.consent_changed": "Consentimiento modificado",
    "timeline.kind.course_enrolled": "Inscripción en un curso",
    "timeline.kind.interaction_call": "Llamada",
    "timeline.kind.interaction_meeting": "Reunión",
    "timeline.kind.interaction_note": "Nota",
    "timeline.kind.legacy": "Actividad anterior",
    "timeline.kind.message_received": "Mensaje recibido",
    "timeline.kind.message_replied": "Mensaje respondido",
    "timeline.kind.note_added": "Nota añadida",
    "timeline.kind.pathway_certificate_issued": "Certificado de itinerario emitido",
    "timeline.kind.pathway_completed": "Itinerario completado",
    "timeline.kind.pathway_encouragement_sent": "Ánimo enviado",
    "timeline.kind.pathway_feedback_sent": "Comentarios enviados sobre una práctica",
    "timeline.kind.pathway_enrolled": "Se unió a un itinerario",
    "timeline.kind.pathway_level_completed": "Nivel del itinerario completado",
    "timeline.kind.pathway_step_completed": "Paso del itinerario completado",
    "timeline.kind.payment_refunded": "Reembolso",
    "timeline.kind.payment_succeeded": "Compra",
    "timeline.kind.session_note_saved": "Nota de sesión guardada",
    "timeline.kind.stage_changed": "Etapa cambiada",
    "timeline.kind.pack_assigned": "Bono asignado",
    "timeline.kind.pack_adjusted": "Bono ajustado",
    "timeline.kind.pack_voided": "Bono anulado",
    "timeline.kind.form_submitted": "Formulario enviado",
    "timeline.kind.signed_up": "Se registró en tu sitio",
    "timeline.kind.email_sent": "Correo enviado",
    "timeline.noteAdded": "nota añadida",
    "timeline.packPosition": "bono {used} de {total}",
    "timeline.stageAuto": "Etapa cambiada automáticamente",
    "timeline.stageManual": "Etapa fijada a mano",
    "timeline.kind.created": "Ficha de cliente creada",
    "timeline.kind.imported": "Añadido por una importación",
    "timeline.kind.merged": "Fichas fusionadas",
  },
};
